<div class="container-fluid" style="margin-bottom: 20px; padding-bottom: 20px;">
  <p-panel>
    <ng-template pTemplate="header" style="color: white;">
        <h3 style="margin-bottom: 0 !important; margin-right:0 !important;" class="list-page-main-header">
          <span><fa-icon [icon]="['fad', 'users-class']"> </fa-icon>Training Courses </span>
        </h3>

      <div class="col pull-right">
        <app-eca-ghost-btn class="card-action-icon float-right"
                           btnIcon="question-circle" btnType="warning"
                           (btnClicked)="openCompanyTrainingCoursesHelp()"></app-eca-ghost-btn>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <div *ngIf="coursesLoading" class="text-center">
        <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
      </div>
      <div *ngIf="!coursesLoading" >
          <p-table [totalRecords]="trainingTypes?.length" #dt [value]="trainingTypes" [columns]="columns" styleClass="p-datatable-striped p-datatable-responsive-eca" [responsive]="true"
                   [scrollable]="!isOnMobile &&    trainingTypes?.length > 5" scrollHeight="500px" dataKey="id"
                   [globalFilterFields]="['name', 'heldOn.dateTime','description','validTo.dateTime','trainingTypeCategory.name']">
            <ng-template pTemplate="caption">
              <div class="row d-flex justify-content-between align-items-center">
                <div class=" col-xl-auto col-lg-auto col-md-6 col-sm-12">
                  <div class="row  justify-content-lg-start justify-content-md-start justify-content-sm-between justify-content-between align-items-center">
                    <div class="col-auto">
                      <h5 class="eca-primary-text h5-relative-font-size">
                        <span *ngIf="trainingTypes ">{{ trainingTypes.length  }}</span>
                        Training Courses
                      </h5>
                    </div>
                    <div class="col-auto">
                      <app-eca-ghost-btn (btnClicked)="addNewItemClick()" btnText="Add"
                                         btnIcon="plus-circle" btnType="success"></app-eca-ghost-btn>
                    </div>
                  </div>
                </div>
                <div class=" col-xl-auto col-lg-auto col-md-6 col-sm-12 ">
                  <div class="row  justify-content-lg-start justify-content-md-end justify-content-sm-between justify-content-between align-items-center">
                    <div class="col-xl-auto col-lg-auto col-md-8 col-sm-8 col-8">
                      <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" class="form-control" id="ctrlTrainingCoursesSearchInput"
                               style="min-width: 150px"
                               placeholder="Search All"
                               (input)="dt.filterGlobal($event.target.value, 'contains')">
                      </span>
                    </div>
                    <div class="col-auto">
                      <app-eca-ghost-btn btnIcon="file-excel" btnText="Export" btnType="primary"
                                         (btnClicked)="exportToExcel()"></app-eca-ghost-btn>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 30%;" pSortableColumn="name">
                  Course Name
                  <p-sortIcon field="name"></p-sortIcon>
                </th>
                <th style="width: 30%;" pSortableColumn="description">
                  Course Description
                  <p-sortIcon field="description"></p-sortIcon>
                </th>
                <th style="width: 30%;" pSortableColumn="trainingTypeCategoryName">
                  Course Category
                  <p-sortIcon field="trainingTypeCategoryName"></p-sortIcon>
                </th>

                <th style="width: 15%;" pSortableColumn="heldOn.dateTime">
                  Held On
                  <p-sortIcon field="heldOn.dateTime"></p-sortIcon>
                </th>
                <th style="width: 15%;" pSortableColumn="validTo.dateTime">
                  Valid To
                  <p-sortIcon field="validTo.dateTime"></p-sortIcon>
                </th>
                <th style="width: 10%"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-trainingType let-columns="columns">
              <tr>
                <td *ngFor="let col of columns">
                  <span class="p-column-title">{{col.header}}: </span>
                  <label>
                    <span *ngIf="col.type=== 'text'">
                      {{trainingType[col.field]}}
                    </span>
                    <span *ngIf="col.type === 'date'">
                      {{trainingType[col.field]?.dateTime | date:'dd/MM/yyyy'}}
                    </span>
                  </label>
                  <label *ngIf="col.type === 'html'" [innerHTML]="trainingType[col.field]">
                  </label>
                </td>
                <td>
                  <app-eca-row-menu (viewBtnClicked)="editItemClick(trainingType)"
                                    viewBtnText="View"
                                    [rowMenuItems]="rowMenuItems"
                                    [contextItem]="trainingType">
                  </app-eca-row-menu>
                </td>
              </tr>
            </ng-template>
          </p-table>
</div>
    </ng-template>
  </p-panel>
</div>
